import React, { useState } from 'react';
import { View, TextInput, StyleSheet } from 'react-native';
import Icon from 'react-native-vector-icons/FontAwesome';

const PasswordInput = ({ onValueChange, style, value }) => {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  const handleValueChange = (text) => {
    if (onValueChange) {
      onValueChange(text);
    }
  };

  return (
    <View>
      <TextInput
        secureTextEntry={!isPasswordVisible}
        onChangeText={handleValueChange}
        style={style}
        value={value}
        // Other TextInput props...
      />
      <Icon
        name={isPasswordVisible ? 'eye-slash' : 'eye'}
        size={20}
        color="#000"
        style={styles.icon}
        onPress={() => setIsPasswordVisible(!isPasswordVisible)}
      />
    </View>
  );
};

const styles = StyleSheet.create({
    icon: {
      position: 'absolute',
      right: 10,
      top: "35%",
    },
  });

export default PasswordInput;
